export function filterUniqueByTranscriptId(arr) {
    return arr.filter((item, index, self) =>
        self.findIndex(i => i.transcript_id === item.transcript_id) === index
    );
}